import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { clear } from '@App/store/actions/similarity';

class SimilaritySearchTrack extends Component {
    static propTypes = {
        track: PropTypes.string.isRequired,
        remove: PropTypes.func.isRequired,
    };

    render() {
        const { track, remove } = this.props;

        return (
            <div className="search-items--item similarity-search-track">
                {track}
                <button className="search-items--remove" type="button" onClick={remove}>
                    <i className="icon icon--clear"></i>
                </button>
            </div>
        );
    }
}

export default connect(
    null,
    dispatch => ({
        remove: () => dispatch(clear()),
    })
)(SimilaritySearchTrack);
